import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const ImagesReviewPage = lazy(() => import('@cobliteam/media/src/pages/ImagesReviewPage'));

const routes = [
  {
    path: Location.CAMERA_IMAGES_MATCH_REVIEW,
    team: 'squad-video-xp',
    component: ImagesReviewPage,
    exact: true,
    featureFlag: 'showMatchReview',
  },
];

export default routes;
